__turbopack_context__.v({
  "actions": "FormView-module-scss-module__aF1rQq__actions",
  "fieldRow": "FormView-module-scss-module__aF1rQq__fieldRow",
  "privacyLink": "FormView-module-scss-module__aF1rQq__privacyLink",
  "privacyNotice": "FormView-module-scss-module__aF1rQq__privacyNotice",
  "root": "FormView-module-scss-module__aF1rQq__root",
});
